export const m = {
  EnterID: "點擊輸入 Tada ID",
  "select-specifications": "點擊選擇充值規格",
  "check-account": "核對充值賬號",
  whatID: "什麼是 Tada ID ？",
  getID: "輸入 Tada ID",
  maskgetID: "輸入 Tada ID",
  "toastTips-format-error": "輸入格式有誤",
  "toastTips-no-exist": "該ID不存在",
  toastTipsPlease: "請先核對充值賬號",
  "common-problem": "常見問題",
  "transaction-succeeded": "交易成功",
  "transaction-failed": "交易失敗",
  "transaction-cancel": "交易取消",
  "whether-account": "1.我充值後怎麼查看是否到賬？",
  "answer-whether-account": "充值後可回到 APP 的【我的】-【錢包】中查看鑽石",
  "no-account": "2.充值後若是沒有到賬怎麼辦？",
  "answer-no-account":
    "請在 APP 的【消息】-【官方消息】-【反饋與幫助】中提交您的問題，並提供以下信息，我們的客服將為您提供幫助。",
  "recharge-money": "1.充值金額和賬戶ID",
  "recharge-time": "2.充值的時間和日期",
  "recharge-shot": "3.支付成功的屏幕截圖",
  "recharge-wrong": "3.充錯賬戶，充錯金額怎麼辦",
  "answer-recharge-wrong":
    "請您在輸入支付密碼前，務必仔細確認充值賬戶 ID 和充值金額信息後再進行購買。錯充金額無法退還，錯充賬戶您可嘗試與實際充值的 ID 用戶聯繫，與對方協商是否願意補償您的充值",
  refund: "4.退款",
  "answer-refund": "抱歉！ Tada 目前不支持任何形式的退款。",
  "buy-enter-link":
    '購買鑽石可通過鏈接進行充值，<a class="web-link" href="https://pay.tadachat.info/" >https://pay.tadachat.info</a> 將鏈接複製在手機瀏覽器中打開，進入購買頁面，核對賬號後，選擇相應的規格並使用合適的支付方式進行支付即可～優惠多多！',
  "buy-notice-a": "注意: <a>pay.tadachat.info</a> 是 Tada 唯一官方購買鑽石網址",
  replace: "更換",
  sureBtn: "確定",
  "pay-style": "選擇支付方式",
  goBack: "回到首頁",
  toastTips: "輸入 Tada ID",
  rechargeFAQ_title: "常見問題",
  PayStatusSuccess_title: "交易成功",
  PayStatusFail_title: "交易失敗",
  PayStatusCancel_title: "交易取消",
  Diamonds_title: "Tada 鑽石充值官方網站",
  "buy-notice":
    "注意  pay.Tadachat.info 是 Tada 唯一官方購買鑽石網站，客服諮詢請進入【消息】-【官方消息】-【反饋與幫助】",
  RechargeHelp_title: "充值幫助",
  openAPP: "打開 Tada APP",
  "buy-diamonds-tit": "購買鑽石服務",
  description:
    "Tada 唯一官方鑽石充值網站 ， Tada 是一款國際化社交軟件，全球超過150多個國家和地區的用戶正在使用 Tada",
  keywords: "Tada 充值,Tada 鑽石充值,Tada 官方充值,Tada 官方充值網站",
  wxPay: "請確認微信支付是否已完成",
  Completed: "已完成支付",
  failedPay: "支付遇到問題,重新支付",
  "toastTips-no-complete": "支付未完成，請重新支付",
  payforType: "充值方式",
  trueText: "確定",
  falseText: "取消",
  alertShowTxt1: "确定用",
  alertShowTxt3: "充值",
  alertShowTxt5: "鑽石？",
  EnterIDTip: "Tada快速充電",
  scanLogin: "為了賬戶隱私和安全，請掃碼登錄",
  scanTip:
    '"提示：點擊 Tada “個人中心/動態”右上角“掃一掃” ,掃碼登錄，同時支持識別二維碼截圖的方式登錄"',
  scanVersion: "請升級 Tada 到 %s 版本後掃碼登錄",
  delAccount: "賬號刪除",
  logout: "退出",
  submit: "提交",
  email_place_holder: "輸入你的郵箱",
  contact_email: "聯繫郵箱",
  provide_email: "請提供您的電子郵箱來接收付款通知",
  email_address: "電子郵箱地址",
};



// WEBPACK FOOTER //
// ./src/lang/zh_HK.js